import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { ADMIN_COLORS } from '@/features/admin/utils/adminAnimations';

interface EmptyStateProps {
  icon: ReactNode;
  message: string;
}

export function EmptyState({ icon, message }: EmptyStateProps) {
  return (
    <motion.div
      key="empty"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="p-8 md:p-12 text-center rounded-xl glass-surface"
      style={{
        border: `2px dashed ${ADMIN_COLORS.border}`,
        backgroundColor: ADMIN_COLORS.surface,
        opacity: 0.8,
      }}
    >
      <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 text-slate-500">
        {icon}
      </div>
      <h3 className="text-lg md:text-xl font-bold mb-2">{message}</h3>
    </motion.div>
  );
}
